<template>
<div class="modal fade" id="company_search" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div>
                    <p class="bold dp-inblock h-30px font-23 mb-30">고객사 검색</p>
                    <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                        <img src="../../../assets/img/close.png" alt="close" class="close-btn">
                    </a>
                    <p class="font-13 pt-10">
                        - 당근농장 고객사 DB 등록된 고객사만 검색됩니다. <br>
                        - 원하는 고객사가 없을 경우 고객사DB에 신규 등록해주세요.
                    </p>
                    <div>
                        <div class="w-100per mt-10 mb-20">
                            <input type="text" v-model="company" @keyup.enter="search()" class="w-85per">
                            <button class="admin-btn-default" @click="search()">검색</button>
                        </div>
                        <div style="max-height: 500px; overflow: auto;">
                            <table class="admin-table-col">
                            <thead>
                                <tr>
                                    <th>고객사</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="selectCompany(item.companyname, item.regid)" data-dismiss="modal" aria-label="Close" class="pointer" v-for="(item, index) of companyList" :key="index">
                                    <td>{{item.companyname}}</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer txt-center">
                <a class="admin-btn-default btn ml-05" data-dismiss="modal" aria-label="Close" @click="$emit('close')">입력완료</a>
            </div> -->
        </div>
    </div>
</div>
</template>
<script>
export default {
    data: () => ({
        company: '', // 고객사 검색 단어
        companyList: [] // 검색된 고객사 결과 리스트
    }),

    methods: {
        search () {
            if (this.company.trim() === '') {
                alert('검색어를 입력해주세요.')
                return false
            }

            var params = {
                company: this.company
            }
            this.axios.get(this.axios.root + this.axios.port + '/sugang/company-search', {
                params: params
            }).then(res => {    
                console.log(res)
                if (res.data.err === 0) {
                    this.companyList = res.data.companyList
                } else {
                    alert(res.data.result)
                }
            })
        },

        selectCompany (company, regid) {
            this.$emit('select', company, regid)
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal {
//     &.modal-overlay {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         position: fixed;
//         z-index: 30;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//     }

//     &-window {
//         background: #fff;
//         border-radius: 4px;
//         overflow: hidden;
//     }

//     &-content {
//         padding: 10px 20px;
//     }

//     &-footer {
//         background: #ccc;
//         padding: 10px;
//         text-align: right;
//     }
// }

// .modal-enter-active,
// .modal-leave-active {
//     transition: opacity 0.4s;

//     .modal-window {
//         transition: opacity 0.4s, transform 0.4s;
//     }
// }

// .modal-leave-active {
//     transition: opacity 0.6s ease 0.4s;
// }

// .modal-enter,
// .modal-leave-to {
//     opacity: 0;

//     .modal-window {
//         opacity: 0;
//         transform: translateY(-20px);
//     }
// }
</style>
